import web from "../web";

class AnneesacademiquesService {
    index(token){
        return web.get("/api/anneesacademiques", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/anneesacademiques", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/anneesacademiques/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/anneesacademiques/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/anneesacademiques/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new AnneesacademiquesService()